import React, { useState } from "react";
import { CheckCircle } from "lucide-react";
import { leadForm } from "../data/siteData";

const LeadForm = () => {
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", phone: "", amazonUrl: "" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const errs = {};
    if (!form.firstName.trim()) errs.firstName = "First name is required";
    if (!form.email.trim()) errs.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email)) errs.email = "Enter a valid email";
    if (!form.amazonUrl.trim()) errs.amazonUrl = "Amazon listing link is required";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length === 0) {
      const submissions = JSON.parse(localStorage.getItem("p3_lead_submissions") || "[]");
      submissions.push({ ...form, submittedAt: new Date().toISOString() });
      localStorage.setItem("p3_lead_submissions", JSON.stringify(submissions));
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-10 text-center">
        <CheckCircle className="mx-auto text-p3-blue mb-4" size={48} />
        <h3 className="font-heading font-bold text-xl text-p3-navy mb-2">Thank you!</h3>
        <p className="text-sm text-p3-muted">{leadForm.successMessage}</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-8 space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <input
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
            placeholder="First name *"
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
          />
          {errors.firstName && <p className="text-xs text-red-500 mt-1">{errors.firstName}</p>}
        </div>
        <div>
          <input
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
            placeholder="Last name"
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
          />
        </div>
      </div>
      <div>
        <input
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Email *"
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
        />
        {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
      </div>
      <div>
        <input
          name="phone"
          value={form.phone}
          onChange={handleChange}
          placeholder="Phone"
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
        />
      </div>
      <div>
        <input
          name="amazonUrl"
          value={form.amazonUrl}
          onChange={handleChange}
          placeholder="Amazon Listing Link *"
          className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-p3-blue/40 text-sm"
        />
        {errors.amazonUrl && <p className="text-xs text-red-500 mt-1">{errors.amazonUrl}</p>}
      </div>
      <button
        type="submit"
        className="w-full bg-p3-gold hover:bg-p3-gold/90 text-p3-navy font-semibold py-3 rounded-lg transition-colors"
      >
        {leadForm.title}
      </button>
    </form>
  );
};

export default LeadForm;
